"use strict";
/**
 * This file is the 2.0 detector for ForgeRock BFP.
 *
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.browserFonts = void 0;
const font_list_1 = require("./font-list");
exports.browserFonts = () => {
    return _detect();
};
const _detect = () => {
    const style = 'position: absolute; visibility: hidden; display: block !important';
    const session = { installedFonts: [] };
    let i, font, div, result = [], e;
    const count = font_list_1.fonts.length;
    const divs = [];
    const template = '<b style="display:inline !important; width:auto !important; font:normal 10px/1 \'X\',sans-serif !important">ww</b>' +
        '<b style="display:inline !important; width:auto !important; font:normal 10px/1 \'X\',monospace !important">ww</b>';
    const fragment = document.createDocumentFragment();
    for (i = 0; i < count; i++) {
        font = font_list_1.fonts[i];
        font = font.replace(/['"<>]/g, '');
        div = document.createElement('div');
        div.innerHTML = template.replace(/X/g, font);
        div.style.cssText = style;
        fragment.appendChild(div);
        divs.push(div);
    }
    let body = document.body;
    body.insertBefore(fragment, body.firstChild);
    for (i = 0; i < count; i++) {
        e = divs[i].getElementsByTagName('b');
        if (e[0].offsetWidth === e[1].offsetWidth) {
            result.push(font_list_1.fonts[i]);
        }
    }
    // do not combine these two loops, remove child will cause reflow
    // and induce severe performance hit
    for (i = 0; i < count; i = i + 1) {
        body.removeChild(divs[i]);
    }
    result.sort();
    session.installedFonts = result;
    return session;
};
//# sourceMappingURL=font-detector.js.map